import Skeleton from '@mui/material/Skeleton';
import { FloatingButtons } from './FloatingButtons';

export const ReasonDetailsSkeleton = () => (
  <>
    <Skeleton data-testid="reason-details-skeleton" height={300} />
    <FloatingButtons />
  </>
);
